export default __webpack_public_path__ + "static/V0_Oikea_valotus-0fe5abd818e1bcc631dea70ea8541da9.jpg";